export default __webpack_public_path__ + "static/media/caret_down_white.c5f23086.svg";